import { render, staticRenderFns } from "./orderInfo.vue?vue&type=template&id=6f224af4&scoped=true&"
import script from "./orderInfo.vue?vue&type=script&lang=js&"
export * from "./orderInfo.vue?vue&type=script&lang=js&"
import style0 from "./orderInfo.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./orderInfo.vue?vue&type=style&index=1&id=6f224af4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f224af4",
  null
  
)

export default component.exports